import { render, staticRenderFns } from "./addliveevent.vue?vue&type=template&id=6001840f"
import script from "./addliveevent.vue?vue&type=script&lang=js"
export * from "./addliveevent.vue?vue&type=script&lang=js"
import style0 from "./addliveevent.vue?vue&type=style&index=0&id=6001840f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports